import JQuery from 'jquery';
import smoothScrollIntoView from 'smooth-scroll-into-view-if-needed';

export interface HTMLElementWithValidate extends HTMLElement {
  meValidate?: () => boolean;
}

export class FormButtonValidate {
  public static frontend(el: HTMLElement, opts: {}) {
    return new FormButtonValidate(el);
  }

  public static cleanup(me: FormButtonValidate) {
    me.unhook();
  }

  public click: (e: JQueryEventObject) => boolean;

  public $button: JQuery;

  constructor(public el: HTMLElement) {
    this.click = (e) => {
      $(el).attr('clicked', 'true');
      if (this.validate() !== true) {
        e.preventDefault();
        return false;
      }
      return true;
    };
    this.$button = $(el).find('button');
    this.$button.on('click', this.click);
  }

  public unhook() {
    this.$button.off('click', this.click);
  }

  public validate(): boolean {
    const $form = $(this.el).parents('form');
    const blocks: HTMLElementWithValidate[] = Array.from(
      $form.find('.me-block').get(),
    );
    let status = true;
    let first: null | HTMLElement = null;
    for (const field of blocks) {
      if (
        field.hasOwnProperty('meValidate') &&
        typeof field.meValidate === 'function'
      ) {
        const res = field.meValidate();
        if (first === null && !res) {
          first = field;
        }
        status = res && status;
      }
    }
    if (first !== null) {
      smoothScrollIntoView(first, {behavior: 'smooth', block: 'center'});
    }
    return status;
  }
}
